module.exports = __webpack_public_path__ + "static/media/constBgPic.d40eaeac.jpeg";